<!-- ⚠ Erst urteilen, wenn die Dashboard-Antwort da ist — sonst sieht
     jede:r kurz den Hinweis, auch mit freigeschalteter Apotheke. -->
@if ((availabilityLoaded$ | async) === false) {
  <app-loading></app-loading>
} @else if (noRedeemablePharmacy) {
  <app-message-box
    [message]="'PAGES.VOUCHER.NO_PHARMACY' | translate"
    [messageType]="MessageType.Info"
  ></app-message-box>
} @else {
  <!-- Die Apotheke steht immer da. Bei genau einer rendert das Dropdown sie
       selbst als reinen Text (single-result), es gibt ja nichts zu wählen. -->
  @if (hasPharmacyChoice) {
    <p class="paragraph">
      {{ "PAGES.VOUCHER.PHARMACY.HINT" | translate }}
    </p>
    <div class="spacer spacer-2"></div>
  }
  <app-input-dropdown
    [label]="'PAGES.VOUCHER.PHARMACY.LABEL' | translate"
    [values]="pharmacyValues"
    [selectedId]="selectedPharmacy"
    (currentValue)="onPharmacyChange($event)"
  ></app-input-dropdown>
  <div class="spacer spacer-3"></div>

  @if (pharmacyBlocked) {
    <!-- Statt des Formulars: mit dieser Apotheke laesst sich nichts einloesen,
         der Code waere also vergebens getippt. -->
    <app-message-box
      [message]="'PAGES.VOUCHER.PHARMACY.NOT_PARTICIPATING' | translate"
      [messageType]="MessageType.Info"
    ></app-message-box>
  } @else {
    <!-- Als Formular, damit ein Handscanner mit Enter direkt absendet. -->
    <form (ngSubmit)="submitCode()">
      <!-- ⚠ Die Beschriftung steht hier und nicht im Feld: sonst saesse der
           Kamera-Knopf daneben um ihre Hoehe zu tief. -->
      <p class="label-form">{{ "PAGES.VOUCHER.CODE.LABEL" | translate }}</p>
      <div class="spacer"></div>

      <div class="voucher-code">
        <app-input-text
          [placeholder]="'PAGES.VOUCHER.CODE.PLACEHOLDER' | translate"
          [errorText]="'PAGES.VOUCHER.CODE.ERROR' | translate"
          [required]="true"
          [invalid]="codeInvalid"
          [autoFocus]="true"
          [value]="code"
          (currentValue)="onCodeChange($event)"
        ></app-input-text>

        <!-- Im Browser nur mit Kamera-API, also ueber HTTPS oder localhost. -->
        @if (scanAvailable) {
          <app-icon-button
            class="voucher-code__scan"
            src="icons/32/scan.svg"
            [attr.aria-label]="'PAGES.VOUCHER.CODE.SCAN' | translate"
            (action)="startScan()"
          ></app-icon-button>
        }
      </div>
      <div class="spacer spacer-half"></div>
      <p class="label-form-helper">
        {{ "PAGES.VOUCHER.CODE.HINT" | translate }}
      </p>

      <!-- Als Meldung statt als Hilfstext: der Knopf darunter ist deaktiviert,
           und der Grund dafuer darf nicht im Kleingedruckten stehen. -->
      @if (needsPharmacyChoice) {
        <div class="spacer spacer-2"></div>
        <app-message-box
          [message]="'PAGES.VOUCHER.PHARMACY.REQUIRED' | translate"
          [messageType]="MessageType.Info"
        ></app-message-box>
      }

      <div class="spacer spacer-3"></div>

      @if ((checkStatus$ | async) === STATES.LOADING) {
        <app-loading></app-loading>
      } @else {
        <app-button
          [label]="'PAGES.VOUCHER.CHECK' | translate"
          [buttonType]="ButtonType.Blue"
          [disabled]="!canCheck"
          [fullWidth]="true"
          (action)="submitCode()"
        ></app-button>
      }
    </form>

    @if ((checkStatus$ | async) === STATES.ERROR) {
      <div class="spacer spacer-2"></div>
      <app-message-box
        [message]="checkError"
        [messageType]="MessageType.Error"
      ></app-message-box>
    }
  }

  <div class="spacer spacer-4"></div>
}

<!-- ⚠ Ausserhalb der Zustands-Verzweigung: das Overlay deckt den ganzen
     Bildschirm ab, waehrend die App per body-Klasse unsichtbar geschaltet ist.
     Das Kamerabild liegt dahinter. -->
@if (scanning) {
  <div class="barcode-scan-overlay">
    <div class="barcode-scan-overlay__frame"></div>
    <p class="barcode-scan-overlay__hint">
      {{ "PAGES.VOUCHER.CODE.SCAN_HINT" | translate }}
    </p>
    <app-button
      [label]="'PAGES.VOUCHER.CODE.SCAN_CANCEL' | translate"
      [buttonType]="ButtonType.Secondary"
      (action)="cancelScan()"
    ></app-button>
  </div>
}
